<template>
	<section>
		<template v-if="!readonly">
			<v-divider/>
			<div class="pa-6 text-center grey lighten-5">
				<AsiBtn :icon="icons.add" @click="createDialog.open()" color="secondary">
					{{ $t('brand.terms.create') }}
				</AsiBtn>
			</div>
		</template>

		<v-divider/>
		<BrandList ref="brandList" :show-actions="!readonly"/>

		<BrandCreateDialog v-if="!readonly && createDialog.isLoaded" :open="createDialog.isOpen"
		                   @cancel="createDialog.close()" @save="reloadList(); createDialog.close()"/>
	</section>
</template>

<script lang="ts">
	import {Vue, Component, Prop} from 'vue-property-decorator';
	import AsiBtn from "@/components/common/AsiBtn.vue";
	import Icon from "@/plugins/icons";
	import BrandCreateDialog from "@/components/brand/admin/BrandCreateDialog.vue";
	import DialogHandler from "@/components/common/DialogHandler";
	import AsiDialogAvatarUpload from "@/components/common/AsiDialogAvatarUpload.vue";
	import BrandList from "@/components/brand/admin/BrandList.vue";

	@Component({
		components: {BrandList, AsiDialogAvatarUpload, BrandCreateDialog, AsiBtn}
	})
	export default class InformationTabBrands extends Vue {

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		private icons = Icon;
		private createDialog: DialogHandler = new DialogHandler();

		private reloadList(): void {
			const brandList = this.$refs.brandList as BrandList;
			brandList.reload();
		}
	}
</script>

<style scoped lang="scss">

</style>
